import { useState, useEffect, useCallback } from "react";
import Select, { ActionMeta } from "react-select";
import * as APIModels from "../../models";
import { DataService } from "../../services/DataService";
import Footer from "../../components/shared/Footer";

export default function UpdateCodes() {
    type MyOptionType = { label: string; value: string };
    let options: MyOptionType[] = [];

    const [stateOptions, setStateOptions] = useState(options);
    const [stateId, setStateId] = useState("");

    const [countyId, setCountyId] = useState("");
    const [countyOptions, setCountyOptions] = useState(options);

    const [counties, setCounties] = useState([] as APIModels.County[]);
    const [portalIdentifier, setPortalIdentifier] = useState("");

    const [divisionId, setDivisionId] = useState("");
    const [divisionOptions, setDivisionOptions] = useState(options);

    const [caseTypeId, setCaseTypeId] = useState("");
    const [caseTypeOptions, setCaseTypeOptions] = useState(options);

    const [filingCodeId, setFilingCodeId] = useState("");
    const [filingCodeOptions, setFilingCodeOptions] = useState(options);

    const [componentId, setComponentId] = useState("");
    const [componentOptions, setComponentOptions] = useState(options);

    const [securityId, setSecurityId] = useState("");
    const [securityOptions, setSecurityOptions] = useState(options);

    const [allCounties, setAllCounties] = useState(false);

    const [divisionsComplete, setDivisionsComplete] = useState(false);
    const [caseTypesComplete, setCaseTypesComplete] = useState(false);
    const [codesComplete, setCodesComplete] = useState(false);
    const [componentsComplete, setComponentsComplete] = useState(false);
    const [securityTypesComplete, setSecurityTypesComplete] = useState(false);

    const c: APIModels.CaseType[] = [];
    const [ePortalCaseTypes, setePortalCaseTypes] = useState(c);

    const cs: APIModels.CaseSubType[] = [];
    const [caseSubTypes, setCaseSubTypes] = useState(cs);

    const [updating, setUpdating] = useState(false);
    const [addNew, setAddNew] = useState(false);

    useEffect(() => {
        DataService.getStates().then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.abbreviation!, label: v.name! };
                });
                setStateOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    useEffect(() => {
        DataService.getCountiesByPortal({
            state: stateId!,
            all: allCounties,
        }).then(
            (resp) => {
                const options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setCountyOptions(options);
                setCounties(resp);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [stateId, allCounties]);

    useEffect(() => {
        DataService.getDivisions({
            countyId: countyId!,
        }).then(
            (resp) => {
                options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setDivisionOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [countyId]);

    const onStateChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setStateId(value?.value ?? "");
    };

    const onCountyChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCountyId(value?.value ?? "");
        /*
                setPortalIdentifier(
            counties.find((c) => c.id == value?.value)?.portalIdentifier
        );
        */
        setPortalIdentifier(
            counties.find((c) => c.id == value?.value)?.portalIdentifier ?? ""
        );
    };

    const onUpdate = () => {
        setUpdating(true);
        <>call update Codes</>;
    };
    const onAddNew = () => {
        setAddNew(true);
    };

    /*
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Update Codes</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Data</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Update Codes
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4">
                    <label htmlFor="selState" className="form-label">
                        State
                    </label>
                    <Select
                        id="selState"
                        name="selState"
                        className="required"
                        value={stateOptions.filter((c) => c.value === stateId)}
                        options={stateOptions}
                        onChange={onStateChange}
                    />
                </div>
                <div
                    className="col-sm-4"
                    style={{
                        display: "inline-block",
                        textAlign: "justify",
                        position: "relative",
                    }}
                >
                    {" "}
                    <div
                        className="form-check"
                        style={{
                            display: "inline-block",
                            position: "absolute",
                            bottom: "0",
                            left: "0",
                        }}
                    >
                        <input
                            className="form-check-input"
                            id="txtUseDocumentEmails"
                            placeholder="UseDoucmentEmails"
                            aria-describedby="inputGroupPrepend"
                            type="checkbox"
                            checked={allCounties}
                            onChange={(event) =>
                                setAllCounties(event.target.checked)
                            }
                        />
                        <label
                            htmlFor="txtUseDocumentEmails"
                            className="form-check-label"
                        >
                            All Counties
                        </label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4">
                    <label htmlFor="selCounty" className="form-label">
                        County
                    </label>
                    <Select
                        id="selCounty"
                        name="selCounty"
                        value={countyOptions.filter(
                            (c) => c.value === countyId
                        )}
                        // filterOption={filterOption}
                        options={countyOptions}
                        onChange={onCountyChange}
                    />
                </div>
            </div>
            <div className="col-sm-6 text-end mb-3">
                <div className="row">
                    <div className="col-sm-3">
                        <button
                            className="btn btn-primary waves-effect waves-light mt-2"
                            type="button"
                            onClick={onAddNew}
                        >
                            Add New County
                        </button>
                    </div>
                    <div className="col-sm-3">
                        <button
                            className="btn btn-primary waves-effect waves-light mt-2"
                            type="button"
                            onClick={onUpdate}
                        >
                            Update Codes
                        </button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-4">
                    {updating && portalIdentifier === "TX" ? (
                        <div className="row">
                            <p>
                                Updating Texas codes will call a job that
                                deletes and updates all data for the selected
                                county. The time this takes varies by county
                            </p>
                        </div>
                    ) : updating && portalIdentifier === "GO" ? (
                        <div className="row">
                            <p>
                                Updating Georgia Odyssey codes will call a
                                stored procedure that deletes all codes and only
                                reinserts the selected county. From here our
                                system will update the rest of the codes
                                automatically as they are called. Using the
                                updated county may take some time the first use
                                because of this.
                            </p>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
    */
    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Update Codes</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Data</a>
                                    </li>

                                    <li className="breadcrumb-item active">
                                        Update Codes
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="header-title">Update Codes</h4>
                                <p>
                                    This is a tool designed to update a county's
                                    codes for filing.
                                </p>
                                <p>
                                    You can either update an existing county's
                                    codes or enter a new county.
                                </p>

                                <div
                                    id="checkout-nav-pills-wizard"
                                    className="twitter-bs-wizard form-wizard-header"
                                >
                                    <div
                                        className="col-sm-3"
                                        style={{ display: "inline-block" }}
                                        /*
                                        style={{
                                            position: "relative",
                                            top: "50%",
                                            left: "40%",
                                        }}
                                        */
                                    >
                                        <ul className="nav nav-pills navtab-bg nav-justified">
                                            <li className="nav-item">
                                                <a
                                                    href="#csv-info"
                                                    className="nav-link text-center active"
                                                    data-bs-toggle="tab"
                                                    data-toggle="tab"
                                                >
                                                    <span className="d-none d-sm-inline">
                                                        Existing County
                                                    </span>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    href="#address-info"
                                                    className="nav-link text-center"
                                                    data-bs-toggle="tab"
                                                    data-toggle="tab"
                                                >
                                                    <span className="d-none d-sm-inline">
                                                        New County
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div>
                                        <div className="card-body">
                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="csv-info"
                                                >
                                                    <p className="mb-3">
                                                        <b>
                                                            Please select the
                                                            state and county in
                                                            which you would like
                                                            to update.
                                                        </b>
                                                    </p>
                                                    <div className="row">
                                                        <div
                                                            className="col"
                                                            style={{
                                                                position:
                                                                    "relative",
                                                                top: "50%",
                                                                left: "37%",
                                                            }}
                                                        >
                                                            <div className="col-sm-3">
                                                                <label
                                                                    htmlFor="selState"
                                                                    className="form-label"
                                                                >
                                                                    State
                                                                </label>
                                                                <Select
                                                                    id="selState"
                                                                    name="selState"
                                                                    className="required"
                                                                    value={stateOptions.filter(
                                                                        (c) =>
                                                                            c.value ===
                                                                            stateId
                                                                    )}
                                                                    options={
                                                                        stateOptions
                                                                    }
                                                                    onChange={
                                                                        onStateChange
                                                                    }
                                                                />
                                                            </div>
                                                            <div
                                                                className="col-sm-3"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "5%",
                                                                    left: "26%",
                                                                }}
                                                            >
                                                                {" "}
                                                                <div
                                                                    className="form-check"
                                                                    style={{
                                                                        display:
                                                                            "inline-block",
                                                                        position:
                                                                            "absolute",
                                                                        bottom: "0",
                                                                        left: "0",
                                                                    }}
                                                                >
                                                                    <input
                                                                        className="form-check-input"
                                                                        id="txtUseDocumentEmails"
                                                                        placeholder="UseDoucmentEmails"
                                                                        aria-describedby="inputGroupPrepend"
                                                                        type="checkbox"
                                                                        checked={
                                                                            allCounties
                                                                        }
                                                                        onChange={(
                                                                            event
                                                                        ) =>
                                                                            setAllCounties(
                                                                                event
                                                                                    .target
                                                                                    .checked
                                                                            )
                                                                        }
                                                                    />
                                                                    <label
                                                                        htmlFor="txtUseDocumentEmails"
                                                                        className="form-check-label"
                                                                    >
                                                                        All
                                                                        Counties
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div
                                                            className="col"
                                                            style={{
                                                                position:
                                                                    "relative",
                                                                top: "50%",
                                                                left: "37%",
                                                            }}
                                                        >
                                                            <div className="col-sm-3">
                                                                <label
                                                                    htmlFor="selCounty"
                                                                    className="form-label"
                                                                >
                                                                    County
                                                                </label>
                                                                <Select
                                                                    id="selCounty"
                                                                    name="selCounty"
                                                                    value={countyOptions.filter(
                                                                        (c) =>
                                                                            c.value ===
                                                                            countyId
                                                                    )}
                                                                    // filterOption={filterOption}
                                                                    options={
                                                                        countyOptions
                                                                    }
                                                                    onChange={
                                                                        onCountyChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div
                                                            className="col-sm-3"
                                                            style={{
                                                                position:
                                                                    "relative",
                                                                top: "50%",
                                                                left: "50%",
                                                            }}
                                                        >
                                                            <button
                                                                className="btn btn-primary waves-effect waves-light mt-2"
                                                                type="button"
                                                                onClick={
                                                                    onUpdate
                                                                }
                                                            >
                                                                Update Codes
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="tab-pane text-center"
                                                    id="address-info"
                                                >
                                                    <div className="">
                                                        <div className="card-body text-top">
                                                            <p
                                                                className="mb-3"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "50%",
                                                                    left: "1%",
                                                                }}
                                                            >
                                                                <b>
                                                                    Please enter
                                                                    the name of
                                                                    the county
                                                                    you want to
                                                                    add exactly
                                                                    how it is
                                                                    listed in
                                                                    the state
                                                                    portal.
                                                                </b>
                                                            </p>
                                                            <div className="row mb-1">
                                                                <div
                                                                    className="col"
                                                                    style={{
                                                                        position:
                                                                            "relative",
                                                                        top: "50%",
                                                                        left: "37%",
                                                                    }}
                                                                >
                                                                    <div className="col-sm-3">
                                                                        <label
                                                                            htmlFor="selState"
                                                                            className="form-label"
                                                                        >
                                                                            State
                                                                        </label>
                                                                        <Select
                                                                            id="selState"
                                                                            name="selState"
                                                                            className="required"
                                                                            value={stateOptions.filter(
                                                                                (
                                                                                    c
                                                                                ) =>
                                                                                    c.value ===
                                                                                    stateId
                                                                            )}
                                                                            options={
                                                                                stateOptions
                                                                            }
                                                                            onChange={
                                                                                onStateChange
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mb-1">
                                                                <div
                                                                    className="col"
                                                                    style={{
                                                                        position:
                                                                            "relative",
                                                                        top: "50%",
                                                                        left: "37%",
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    <div className="col-sm-3">
                                                                        <label
                                                                            htmlFor="selState"
                                                                            className="form-label"
                                                                        >
                                                                            County
                                                                            Name
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            //value={doc.documentType}

                                                                            aria-describedby="inputGroupPrepend"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-sm-3"
                                                                    style={{
                                                                        position:
                                                                            "relative",
                                                                        top: "50%",
                                                                        left: "50%",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn btn-primary waves-effect waves-light mt-2"
                                                                        type="button"
                                                                        onClick={
                                                                            onAddNew
                                                                        }
                                                                    >
                                                                        Add New
                                                                        County
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
